import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import QRGenerator from './components/QRGenerator';
import AudioPlayer from './components/AudioPlayer';
import './App.css';

function App() {
  return (
    <Router>
      <div className="App">
        <Routes>
          <Route path="/" element={<QRGenerator />} />
          <Route path="/play/:songId" element={<AudioPlayer />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;